export const DEFAULT_SEARCH_PAGE_SIZE = 24;
export const PAGE_SIZE_OPTIONS = [24, 48, 96];

/**
 * Ceiling for a URL-supplied `numberOfResults`. Coveo puts no upper bound on
 * it, so raw URL input is clamped here to prevent request amplification (200
 * was agreed in the compass-ui#2465 review). Lives here rather than next to
 * MAX_FIRST_RESULT so client bundles can use it without pulling in
 * @coveo/headless-react/ssr.
 */
export const MAX_NUMBER_OF_RESULTS = 200;

/**
 * Fields required for product cards on listing surfaces.
 * Specified explicitly because headless defaults to MinimumFieldsToInclude
 * (7 system fields) when fieldsToInclude is not provided.
 * The Atomic path registers these via AtomicSearchInterface.fieldsToInclude;
 * the headless path needs them on the result-list controller directly.
 */
export const LISTING_FIELDS_TO_INCLUDE = [
  'ec_sale',
  'ec_name',
  'ec_thumbnails',
  'ec_price',
  'ec_price_filter',
  'ec_rating',
  'ec_rating_count',
  'ec_category',
  'publisher_name',
  'publisher_id',
  'ec_product_id',
  'ec_tags',
  'ec_is_new_release',
  'min_unity_version',
  'ec_flash_teaser_starts_at',
  'ec_flash_promo_starts_at',
];
